/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { tagModelSchema } from "../tagModelSchema.ts";
import { z } from "zod";

export const getApiTagsIdPathParamsSchema = z.object({
    "Id": z.coerce.number().int().describe("Идентификатор жанра")
    })

/**
 * @description Модель жанра
 */
export const getApiTagsId200Schema = z.lazy(() => tagModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTagsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTagsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTagsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Жанр не найден
 */
export const getApiTagsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTagsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTagsIdQueryResponseSchema = z.lazy(() => getApiTagsId200Schema)